import { t, te } from '@/global/i18n'

const showBidder = (bidderCompanyIndex) => {
  return `Bidder ${bidderCompanyIndex + 1}`
}

const calculatePercentage = (value, total) => {
  if (total === 0) return 0
  return ((value / total) * 100).toFixed(2)
}

const calculateDeltaPercentage = (originalValue, delta) => {
  if (delta === 0) return '0%'
  if (originalValue === 0) return delta > 0 ? '100%' : '0%'

  // Calculate the percentage change
  const percentageChange = (delta / originalValue) * 100
  return percentageChange.toFixed(0) + '%'
}

const isPositiveChange = (value, isPositiveGood = true) => {
  if (isPositiveGood) {
    return value > 0
  } else {
    return value < 0
  }
}

const getInitials = (firstName, lastName) => {
  if (!firstName && !lastName) return ''
  if (firstName && lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
  }
  if (firstName && !lastName) {
    return firstName.charAt(0).toUpperCase()
  }
  if (!firstName && lastName) {
    return lastName.charAt(0).toUpperCase()
  }
  return ''
}

const isValidEmail = (email) => {
  // More secure regex that prevents ReDoS attacks by avoiding nested quantifiers
  // and using atomic groups-like behavior with explicit character classes
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
  return emailRegex.test(email)
}

const normalizeCaseId = (caseId) => {
  if (caseId === null || caseId === undefined) {
    return null
  }

  return String(caseId)
}

const hasMatchingCaseId = (left, right) => {
  const normalizedLeft = normalizeCaseId(left)
  const normalizedRight = normalizeCaseId(right)

  if (normalizedLeft === null || normalizedRight === null) {
    return false
  }

  return normalizedLeft === normalizedRight
}

const getApiErrorMessage = (error, fallback = null) => {
  const apiError = error?.apiErrors?.[0]
  if (apiError) {
    const code = apiError.code
    if (code && te(`errors.api.${code}`)) {
      return t(`errors.api.${code}`)
    }
    if (apiError.message) {
      return apiError.message
    }
  }
  if (error?.response?.data?.message) {
    return error.response.data.message
  }
  return fallback
}

export {
  showBidder,
  calculatePercentage,
  calculateDeltaPercentage,
  isPositiveChange,
  getInitials,
  isValidEmail,
  normalizeCaseId,
  hasMatchingCaseId,
  getApiErrorMessage,
}
